import { debounce } from '../utilities/common';

(function module() {
  const modules = Array.from(document.querySelectorAll('.module-themes__theme'));

  function inViewport(element) {
    const docViewBottom = window.scrollY + window.innerHeight;
    const elementTop = element.offsetTop;

    return ((elementTop + 100) <= docViewBottom);
  }

  function loadModules() {
    modules.map(module => {
      if(inViewport(module)) {
        module.classList.add('visible');
      }
    });
  }

  window.addEventListener('load', loadModules);
  window.addEventListener('scroll', debounce(loadModules));
}());
